/*! Scroll reveal -- opacity only, no dependencies.
 *
 * Replaces AOS. Elements carry `data-reveal`; base.css hides them (opacity: 0)
 * only on viewports >= 990px, only when motion is allowed, and only while
 * `<html>` carries `reveal-js` (added by an inline script in the layout head,
 * removed again if this file never runs). This script adds `is-revealed` the
 * first time an element enters the viewport. Below 990px, with reduced
 * motion, or without IntersectionObserver, everything is revealed at once so
 * nothing above the fold is ever gated on scroll.
 */
(() => {
  window.__revealReady = true;

  const SELECTOR = '[data-reveal]';
  const desktop = window.matchMedia('(min-width: 990px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((el) => el.classList.add('is-revealed'));
  };

  const listen = (mql, handler) => {
    if (typeof mql.addEventListener === 'function') mql.addEventListener('change', handler);
    else if (typeof mql.addListener === 'function') mql.addListener(handler);
  };

  const init = () => {
    if (!('IntersectionObserver' in window) || !desktop.matches || reduced.matches) {
      revealAll();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    const observe = (root = document) => {
      root.querySelectorAll(SELECTOR).forEach((el) => {
        if (!el.classList.contains('is-revealed')) observer.observe(el);
      });
    };

    observe();

    const onChange = () => {
      if (desktop.matches && !reduced.matches) return;
      observer.disconnect();
      revealAll();
    };
    listen(desktop, onChange);
    listen(reduced, onChange);

    // Theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
